module.exports = "https://static-www.niulinkcloud.com/_next/static/media/pc.c83586afddecd8b5d93429a13529afff.png";